import React,{ useEffect } from 'react';
import Form from './Form';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useNavigate,useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useEntityCrud } from '../../hooks/useEntityCrud';

const Update = () => {

    const { id } = useParams();
    const {readData} = useEntityCrud('Person/GetPerson?PersonId=' + id);
    const {addData: updateData} = useEntityCrud('Person/UpdatePerson');
    const navigate = useNavigate();

    const initialValues = {
        name: '',
        lastName: '',
        nationalCode: '',
        phone: '',
        cellphone: '',
        email: '',
        branchId: '',
        personTypeId: ''
    };

    useEffect(() => {
        readData().then(({data}) => {
            if(data.status)
                formik.setValues({
                    ...data.result,
                    cellphone: data.result.cellphone.slice(0,4) + '-' + data.result.cellphone.slice(4,11)
                });
        });
    },[]);
    
    const validationSchema = Yup.object({
        name: Yup.string()
        .required(),
        lastName: Yup.string()
        .required(),
        nationalCode: Yup.string()
        .test('nationalCode','کد ملی وارد شده معتبر نمی باشد',code => {
            if(!code || code.length != 10)
                return false;
            let L = code.length;
            if(L < 8 || parseInt(code,10) == 0) return false;
            code = ('0000' + code).substr(L + 4 - 10);
            if(parseInt(code.substr(3,6),10)==0) return false;
            let c = parseInt(code.substr(9,1),10);
            let s = 0;
            for(let i = 0;i < 9;i++)
                s += parseInt(code.substr(i,1),10) * (10 - i);
            s = s % 11;
            return (s < 2 && c == s) || (s >= 2 && c == (11 - s));
        })
        .required(),
        // phone: Yup.string().matches(/^[0-9\-\(\)]*$/,'شماره تماس وارد شده معتبر نیست').required(),
        cellphone: Yup.string()
        .test('cellphone','شماره همراه وارد شده معتبر نمی باشد',value => {
            return !value || (value && /^\d+$/.test(value.toString().replace('-','')) && value.startsWith('09') && value.length == 12);
        }),
        personTypeId: Yup.number()
        .required(),
        branchId: Yup.number()
        .required()
    });
    
    const onSubmit = (values) => {
        document.getElementById('btn-submit-form').classList.add('btn-loading');
        const postedData = {
            id,
            name: values.name,
            lastName: values.lastName,
            nationalCode: values.nationalCode,
            phone: values.phone,
            cellphone: values.cellphone.replace('-',''),
            email: values.email ? values.email : '',
            branchId: values.branchId,
            personTypeId: values.personTypeId,
            roleId: values.roleId,
            branchTitle: ''
       };
       updateData(postedData).then(({data}) => {
            if(data.status){
                toast.success('به روزرسانی پرسنل با موفقیت انجام شد');
                return navigate('/personnel');
            }else
                data.errors.map(error => toast.error(error.message));
        }).finally(() => document.getElementById('btn-submit-form').classList.remove('btn-loading'));
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit,
        validationSchema: validationSchema
    });

    const handleBack = () => {
        navigate('/personnel',{replace: true});
    }

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <div className="card-title">ویرایش پرسنل</div>
                <a className="backIconLink" onClick={handleBack}><i className="fa fa-arrow-left" title="بازگشت"></i></a>
            </div>
            <div className="card-body">
                <Form formik={formik} />
            </div>
        </div>
    );
}

export default Update;